import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=66a1e684&scoped=true"
import script from "./ProgramsList.vue?vue&type=script&lang=js"
export * from "./ProgramsList.vue?vue&type=script&lang=js"
import style0 from "./ProgramsList.vue?vue&type=style&index=0&id=66a1e684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a1e684",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationProgramsListHideCompletedSwitch: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/HideCompletedSwitch.vue').default,EducationProgramsListTrajectoriesTrajectoryCards: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/Trajectories/TrajectoryCards/TrajectoryCards.vue').default,EducationProgramsListTabsTheTabs: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/Tabs/TheTabs.vue').default,EducationProgramsListProgramTheProgram: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/Program/TheProgram.vue').default,EducationProgramsListCardsLoader: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/CardsLoader.vue').default,EducationProgramsListProgramPlug: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/ProgramPlug.vue').default})
